import React, { useState } from 'react';
import { api } from '../services/api';
import './ChangePasswordModal.css';
import { AuthProvider, useAuth } from './../contexts/AuthContext';

interface ChangePasswordModalProps {
  onPasswordChanged: (user: any) => void;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({ onPasswordChanged }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { logout, user } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    // Validation
    if (newPassword.length < 6) {
      setError('Le nouveau mot de passe doit contenir au moins 6 caractères');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    if (oldPassword === newPassword) {
      setError('Le nouveau mot de passe doit être différent de l\'ancien');
      return;
    }

    setLoading(true);

    try {
      const response = await api.post('/auth/change-password', {
        old_password: oldPassword,
        new_password: newPassword
      });

      // Mise à jour de l'utilisateur
      onPasswordChanged(response.data.user);
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Erreur lors du changement de mot de passe');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="password-modal-overlay">
      <div className="password-modal">
        <div className="password-modal-header">
          <h2>🔒 Changement de mot de passe obligatoire</h2>
          <p>Pour des raisons de sécurité, vous devez changer votre mot de passe lors de votre première connexion.</p>
        </div>

        <form onSubmit={handleSubmit} className="password-modal-form">
          <div className="form-group">
            <label htmlFor="old-password">Mot de passe actuel *</label>
            <input
              id="old-password"
              type="password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              placeholder="••••••••"
              required
              autoComplete="current-password"
            />
          </div>

          <div className="form-group">
            <label htmlFor="new-password">Nouveau mot de passe *</label>
            <input
              id="new-password"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="••••••••"
              required
              minLength={6}
              autoComplete="new-password"
            />
            <small className="form-hint">Minimum 6 caractères</small>
          </div>

          <div className="form-group">
            <label htmlFor="confirm-password">Confirmer le nouveau mot de passe *</label>
            <input
              id="confirm-password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="••••••••"
              required
              minLength={6}
              autoComplete="new-password"
            />
          </div>

          {error && (
            <div className="error-message">
              ⚠️ {error}
            </div>
          )}

          <button 
            type="submit" 
            className="btn-primary btn-full"
            disabled={loading}
          >
            {loading ? 'Changement en cours...' : 'Changer le mot de passe'}
          </button>
        </form>
        
        <button onClick={logout} className="nav-link logout-btn">
          🚪 Déconnexion ({user?.name})
        </button>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
